(function ($) {
  var wrap = $("[data-faq-filter]");
  var timeoutId = null;
  var loading_icon = wrap.find("[data-faq-loader]");

  function getURLParameter(url, name) {
    return (RegExp(name + "=" + "(.+?)(&|$)").exec(url) || [, null])[1];
  }

  $(document).ready(function () {
    $(".faq-tabs a").on("click", function (event) {
      event.preventDefault();

      var currentTab = $(this);
      var hiddenFiltersInput = $("#filters_" + currentTab.data("type"));

      // If the user clicked on the 'All' tab, remove any other active tabs and only make the 'All' tab active
      if (currentTab.data("slug") === "all") {
        // If the tab is already active, remove active class and remove the item from hidden input
        if (currentTab.hasClass("active")) {
          currentTab.removeClass("active");

          // Remove the 'All' value
          edit_faq_filter_inputs(hiddenFiltersInput, "all", "remove");
        }
        // Otherwise, make the All tab the only active tab and replace hidden input with 'all' value
        else {
          currentTab.siblings("a").removeClass("active");
          currentTab.addClass("active");

          // Remove the 'All' value
          edit_faq_filter_inputs(hiddenFiltersInput, "all", "replace");
        }
      } else {
        currentTab.siblings('a[data-slug="all"]').removeClass("active");

        // Remove the 'All' value
        edit_faq_filter_inputs(hiddenFiltersInput, "all", "remove");

        // If the user clicked on any of the other tabs
        if (currentTab.hasClass("active")) {
          currentTab.removeClass("active");

          // Remove the value from the hidden inputs
          edit_faq_filter_inputs(
            hiddenFiltersInput,
            currentTab.data("slug"),
            "remove"
          );
        } else {
          currentTab.addClass("active");

          // Add the new value to the hidden inputs
          edit_faq_filter_inputs(
            hiddenFiltersInput,
            currentTab.data("slug"),
            "add"
          );
        }
      }

      // Show the results
      show_faq_results();

      return false;
    });

    $("body").on(
      "click",
      "[data-faq-filter] [data-ajax-pager] a",
      function (event) {
        event.preventDefault();

        $(this).parent().find(".page-numbers").removeClass("current");
        $(this).addClass("current");
        var currentPage = getURLParameter($(this).attr("href"), "paged");

        $("#filters_page").val(currentPage);

        show_faq_results();

        return false;
      }
    );
  });

  function edit_faq_filter_inputs(inputField, value, action) {
    var currentFilters = "";
    var newFilter = value.toString();

    if (inputField.val() !== undefined) {
      currentFilters = inputField.val().split(",");

      if (action === "remove") {
        var i = currentFilters.indexOf(newFilter);
        while (i !== -1) {
          currentFilters.splice(i, 1);
          i = currentFilters.indexOf(newFilter);
        }
        inputField.val(currentFilters.join(","));
      } else if (action === "add") {
        if (!currentFilters.includes(newFilter)) {
          currentFilters.push(newFilter);
          inputField.val(currentFilters.join(","));
        }
      } else if (action === "replace") {
        inputField.val(value);
      } else {
        if (currentFilters.includes(newFilter)) {
          var i = currentFilters.indexOf(newFilter);
          while (i !== -1) {
            currentFilters.splice(i, 1);
            i = currentFilters.indexOf(newFilter);
          }
          inputField.val(currentFilters.join(",") + "," + newFilter);
        } else if (inputField.val() !== "") {
          inputField.val(inputField.val() + "," + newFilter);
        } else {
          inputField.val(newFilter);
        }
      }
    } else if (newFilter !== "") {
      inputField.val(newFilter);
    }
  }

  function show_faq_results() {
    var categories_input = $("#filters_category");
    var locations_input = $("#filters_location");
    var page_num = parseInt($("#filters_page").val());
    var results_container = $("[data-faq-filter-results]");
    var categories_list = "";
    var locations_list = "";

    if (categories_input.val()) {
      categories_list = categories_input.val().split(",");
    }

    if (locations_input.val()) {
      locations_list = locations_input.val().split(",");
    }

    // Show the results
    clearTimeout(timeoutId);

    timeoutId = setTimeout(function () {
      // Reset the page number since we're returning new results
      $("#filters_page").val(1);

      // Make all buttons disabled until the results return
      $(".faq-tabs a").addClass("disabled");

      // Show the loading icon and hide previous results
      loading_icon.show();
      results_container.hide();

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "ccl_filter_faq",
          categories: categories_list,
          locations: locations_list,
          page: page_num,
        },
        success: function (res) {
          results_container.html(res);

          loading_icon.hide();

          if (res !== 0) {
            results_container.show();
          }

          // Remove disabled class on buttons
          $(".faq-tabs a").removeClass("disabled");
        },
        error: function (err) {
          console.error(err);
        },
      });
    }, 750); // wait for 750ms of inactivity before sending data to server
  }
})(jQuery);
